import { render, staticRenderFns } from "./productOnPromotion.vue?vue&type=template&id=12668684"
import script from "./productOnPromotion.vue?vue&type=script&lang=js"
export * from "./productOnPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports